import { useTranslation } from "react-i18next";
import { useGDPRStore } from "../../stores/gdprStore";
import { Cookie } from "lucide-react";

interface CookieSettingsButtonProps {
    variant?: "text" | "button" | "icon";
    className?: string;
    onClick?: () => void;
}

/**
 * A reusable button to open the GDPR preferences modal
 * Can be placed in footer, settings pages, or anywhere users might
 * want to manage their cookie preferences
 */
export function CookieSettingsButton({
    variant = "text",
    className = "",
    onClick
}: CookieSettingsButtonProps) {
    const { t } = useTranslation("common");
    const { openPreferencesModal } = useGDPRStore();

    const handleClick = () => {
        openPreferencesModal();
        if (onClick) onClick();
    };

    if (variant === "icon") {
        return (
            <button
                onClick={handleClick}
                className={`p-2 text-neutral-500 hover:text-accent-primary transition-colors rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 ${className}`}
                aria-label={t("gdpr.managePreferences") as string}
            >
                <Cookie className="w-5 h-5" />
            </button>
        );
    }

    if (variant === "button") {
        return (
            <button
                onClick={handleClick}
                className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-neutral-700 dark:text-neutral-300 bg-neutral-100 dark:bg-neutral-800 hover:bg-neutral-200 dark:hover:bg-neutral-700 rounded-lg transition-colors ${className}`}
            >
                <Cookie className="w-4 h-4" />
                {t("gdpr.managePreferences")}
            </button>
        );
    }

    // Default: text variant
    return (
        <button
            onClick={handleClick}
            className={`text-sm text-neutral-500 hover:text-accent-primary transition-colors ${className}`}
        >
            {t("gdpr.managePreferences")}
        </button>
    );
}
